import { render } from "./App.vue?vue&type=template&id=0d8efd5d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0d8efd5d&lang=scss"

import exportComponent from "C:\\Users\\User\\Desktop\\Workout-Tracker\\workout-tracker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])